var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{on:{"click":function($event){return _vm.$router.go(-1)}}},[_vm._v("← "+_vm._s(_vm.idioma === 'en' ? 'go back' : 'volver'))])
}
var staticRenderFns = []

export { render, staticRenderFns }